module.exports = __webpack_public_path__ + "img/art4-img3.ac7100a1.jpeg";